import React, {Component} from 'react';

class Markdown extends Component {

    constructor(props) {
        super(props);

        this.state = {
            markdown: null,
            loading: true
        };
    }

    loadMarkdown(url) {
        fetch(url)
            .then((r) => r.text())
            .then(text => {
                this.setMarkdown(text);
            }).catch(e => {

        });
    }

    setMarkdown(text) {
        this.setState({
            markdown: text,
            loading: false
        });
    }

    render() {
        return <div/>;
    }
}

export default Markdown;



// WEBPACK FOOTER //
// ./src/Components/Markdown.js